module.exports = __webpack_public_path__ + "static/media/profilegrey.53966459.svg";